module.exports = __webpack_public_path__ + "img/proyecto_16.49aaf291.png";